import { api } from '@/lib/axios';
import { EmployeeFormData } from '../types/employee.types';

export const createEmployee = (data: EmployeeFormData) => {
  return api.post('/api/employees/', data);
};
